import { render, staticRenderFns } from "./addWorkPlate.vue?vue&type=template&id=48efe798&scoped=true&"
import script from "./addWorkPlate.vue?vue&type=script&lang=js&"
export * from "./addWorkPlate.vue?vue&type=script&lang=js&"
import style0 from "./addWorkPlate.vue?vue&type=style&index=0&id=48efe798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48efe798",
  null
  
)

export default component.exports